<section class="ui-stat-grid">
  <ng-content />
</section>
